import { planResourcesService } from '@/services/plan-resources';
import type { PlanResource } from '@/services/plan-resources/types';
import { useQuery } from '@tanstack/react-query';

export function useProductAssistances(productId?: number | string) {
  const normalizedProductId = productId != null ? String(productId) : '';

  return useQuery({
    queryKey: ['business', 'product-assistances', normalizedProductId],
    enabled: Boolean(normalizedProductId),
    queryFn: async (): Promise<PlanResource[]> => {
      const result =
        await planResourcesService.listByProduct(normalizedProductId);
      if (!result.success || !result.data) {
        throw new Error(result.error || 'Falha ao buscar assistências');
      }
      return result.data;
    },
  });
}
